import {Component, inject, input, output} from '@angular/core';
import {ButtonComponent} from '../../../../../../shared/components/button/button.component';
import {IconsComponent} from '../../../../../../shared/components/icons/icons.component';
import {ResultsStore} from '../../../../../../shared/store/results.store';
import {IItem} from '../../../../../../types/IItem';

@Component({
  selector: 'app-results-table-row-actions',
  imports: [
    ButtonComponent,
    IconsComponent,
  ],
  templateUrl: './results-table-row-actions.html',
  styleUrl: './results-table-row-actions.css',
})
export class ResultsTableRowActions {
  item = input.required<IItem>();
  compareClicked = output<void>();
  quoteClicked = output<void>();

  resultsStore = inject(ResultsStore);

  compareButtonClicked() {
    this.compareClicked.emit();
  }

  addToQuoteButtonClicked() {
    this.quoteClicked.emit();
  }
}
